module.exports = __webpack_public_path__ + "static/img/6677_phase_function_Paper_PointsHejduk_Prediction.d7051ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6677_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EY/0
// module chunks = 0